import React, { useEffect, ChangeEvent } from "react";
import { Row, Column } from "components/Layout/Grid";
import Text from "components/Text";

import { PhoneNumberOutput } from "utils/PhoneNumber";
import { useEnvironment } from "hooks/useEnvironment";
import { EnvironmentTypes } from "pages/OpenProtocol/Description/interface";
import { AdditionalContactProps } from './interface';

import { InputName, InputEmail, InputPhone } from './styles';

export const AdditionalContact: React.FC<AdditionalContactProps> = (props) => {
  const {
    contactName,
    setContactName,
    contactMailAddress,
    setContactMailAddress,
    contactPhoneNumber,
    setContactPhoneNumber
  } = props;

  const development = useEnvironment();

  useEffect(() => {
    const environment = process.env.REACT_APP_HOME_URL;

    if (development || environment === EnvironmentTypes.dev || environment === EnvironmentTypes.qas) {
      setContactName("CCare Dev");
      setContactMailAddress("dev@apinteractive.com.br");
      setContactPhoneNumber("99999999999");
    }
  }, []);

  return (
    <Row className="mt-5 flex-md-column">
      <Column className="flex-1">
        <Text className="mb-2 color-blue-gray" size={12}>
          Nome do Contato
        </Text>
        <InputName
          onChange={(e: ChangeEvent<HTMLInputElement>) => setContactName(e.target.value)}
          value={contactName}
        />
      </Column>

      <Column className="flex-1 ml-4 ml-sm-0 mt-md-2">
        <Text className="mb-2 color-blue-gray" size={12}>
          E-mail
        </Text>
        <InputEmail
          onChange={(e: ChangeEvent<HTMLInputElement>) => setContactMailAddress(e.target.value)}
          value={contactMailAddress}
        />
      </Column>

      <Column className="flex-1 ml-4 ml-sm-0 mt-md-2">
        <Text className="mb-2 color-blue-gray" size={12}>
          Telefone (opcional)
        </Text>
        <InputPhone
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setContactPhoneNumber(PhoneNumberOutput(e.target.value))
          }
          value={PhoneNumberOutput(contactPhoneNumber)}
        />
      </Column>
    </Row>
  );
};
